import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { BarChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/bar-chart-converter';
import { LineChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/line-chart-converter';
import { AreaChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/area-chart-converter';
import { PieChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/pie-chart-converter';
import { DoughnutChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/doughnut-chart-converter';
import { RadarChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/radar-chart-converter';
import { ScatterChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/scatter-chart-converter';
import { StockChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/stock-chart-converter';
import { OfPieChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/of-pie-chart-converter';
import { BubbleChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/bubble-chart-converter';
import type { SubChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/sub-chart-converter';

export class SubChartConverterFactory {
    // eslint-disable-next-line complexity
    public static getSubChartConverterByType(type: SubChartType): typeof SubChartConverter | undefined {
        switch (type) {
            case SubChartType.BarChart:
            case SubChartType.Bar3DChart:
                return BarChartConverter;
            case SubChartType.LineChart:
            case SubChartType.Line3DChart:
                return LineChartConverter;
            case SubChartType.AreaChart:
            case SubChartType.Area3DChart:
                return AreaChartConverter;
            case SubChartType.PieChart:
            case SubChartType.Pie3DChart:
                return PieChartConverter;
            case SubChartType.DoughnutChart:
                return DoughnutChartConverter;
            case SubChartType.RadarChart:
                return RadarChartConverter;
            case SubChartType.ScatterChart:
                return ScatterChartConverter;
            case SubChartType.StockChart:
                return StockChartConverter;
            case SubChartType.OfPieChart:
                return OfPieChartConverter;
            case SubChartType.BubbleChart:
                return BubbleChartConverter;
        }
    }
}
